import useTeamMemberFilterCheckbox from '../hooks/useTeamMemberFilterCheckbox';

const useContextFilterData = () => {
  const { resetAllContextFilters } = useTeamMemberFilterCheckbox();

  return {
    filterData: {},
    navDataSource: [],
    currentPostType: 'team-member-grid',
    postTitle: 'Team Members',
    resetAllContextFilters
  };
};

export default useContextFilterData;
